export const mariaResults = {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    isChannelActivated(channel) {
      return this.campaign.messages_dispatches_channels.includes(channel)
    },
  },
}
